import { render } from "./CounterpartyStatisticsDetailsModal.vue?vue&type=template&id=038b95ba&ts=true"
import script from "./CounterpartyStatisticsDetailsModal.vue?vue&type=script&lang=ts"
export * from "./CounterpartyStatisticsDetailsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__